// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * An SVG icon component that renders the QuickBooks icon.
 * This is the official QuickBooks green circle with white "QB" mark.
 *
 * Supports MUI's color system: when a `color` prop is provided (e.g., "disabled",
 * "action"), the icon renders in that color (grayscale-friendly). When omitted,
 * it uses the official QuickBooks brand colors.
 */
export function QuickBooksOnlineIcon(props: SvgIconProps) {
  // If color is set, SvgIcon will have the correct color so the circle fill
  // should use currentColor. The inner QB mark always stays white so it
  // remains visible against the circle in both color and grayscale modes.
  const circleColor = props.color ? 'currentColor' : '#2ca01c';

  return (
    <SvgIcon {...props} viewBox="0 0 128 128">
      <title>QuickBooks Online icon</title>
      <path
        d="M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64z"
        fill={circleColor}
      />
      <path
        d="M17.778 64a24.889 24.889 0 0 0 24.889 24.889h3.555v-9.245h-3.555a15.645 15.645 0 1 1 0-31.289H51.2v48.356a9.248 9.248 0 0 0 9.244 9.245V39.111H42.667A24.889 24.889 0 0 0 17.777 64zm67.555-24.889h-3.555v9.245h3.555a15.645 15.645 0 0 1 0 31.288H76.8V31.29a9.244 9.244 0 0 0-9.244-9.245V88.89h17.777a24.888 24.888 0 0 0 0-49.778z"
        fill="#fff"
      />
    </SvgIcon>
  );
}
